import {PeriodeParametrageFacturation} from "./periode-parametrage-facturation";
import {PeriodeParametrageFacturationFraisFixe} from "./periode-parametrage-facturation-frais-fixe";

export class LigneParametrageFacturation {
  id: number;

  siteId: number;
  siteLibelle: string;

  offreAlimentaireId: number;
  offreAlimentaireLibelle: string;

  prestationId: number;
  prestationLibelle: string;

  repasId: number;
  repasLibelle: string;

  regimeId: number;
  regimeLibelle: string;

  pointFacturationId: number;
  pointFacturationLibelle: string;

  pointLivraisonId: number;
  pointLivraisonLibelle: string;

  elementFacturableId: number;
  elementFacturableLibelle: string;

  taxeEFId: number;
  taxeEFLibelle: string;

  taxeFFId: number;
  taxeFFLibelle: string;

  fraisFixeId: number;
  fraisFixeLibelle: string;

  prixVenteHT: number;

  periodeParametrageFacturationList: PeriodeParametrageFacturation[];

  periodeParametrageFacturationFraisFixeList: PeriodeParametrageFacturationFraisFixe[];

  familleFacturationId: number;
  familleFacturationLibelle: string;

  static getAllGraphQlProperties() {
    return `
    id,
    siteId,
    siteLibelle,
    offreAlimentaireId,
    offreAlimentaireLibelle,
    prestationId,
    prestationLibelle,
    repasId,
    repasLibelle,
    regimeId,
    regimeLibelle,
    pointFacturationId,
    pointFacturationLibelle,
    pointLivraisonId,
    pointLivraisonLibelle,
    elementFacturableId,
    elementFacturableLibelle,
    taxeEFId,
    taxeEFLibelle,
    taxeFFId,
    taxeFFLibelle,
    fraisFixeId,
    fraisFixeLibelle,
    periodeParametrageFacturationList {
      id,
      dateDebut,
      prixVenteHT
    },
    periodeParametrageFacturationFraisFixeList {
      id,
      dateDebut,
      fraisFixeHT
    },
    familleFacturationId,
    familleFacturationLibelle,
    `
  }
}
